<ion-app>
  @if (!isNative) {
    <header>
      <img [routerLink]="'/'" src="assets/images/varsom.svg" alt="logo" />
      RegObs
    </header>
  }
  <ion-menu [class.ion-menu--web]="!isNative" contentId="main-content" type="overlay" side="end" maxEdgeStart="0">
    @defer {
      <app-side-menu></app-side-menu>
    }
  </ion-menu>
  <ion-router-outlet
    id="main-content"
    [class.main-content--web]="!isNative"
    [swipeGesture]="(swipeBackEnabled$ | async)!"
  ></ion-router-outlet>
  <!-- TODO: Ikke rendre gps debug default -->
  <app-gps-debug></app-gps-debug>
</ion-app>
